"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const byHandVerbs = {
    // default "make"
    "iron-ore": "gather",
    "copper-ore": "gather",
    stone: "gather",
    coal: "gather",
    seed: "gather",
    begin: "Begin",
    money: "Mint",
    bank: "Build",
    "fire-wizard": "Hire",
    "necro-wizard": "Hire",
    "arcane-wizard": "Hire",
    "wizard-orb": "ponder",
    "research-car": "Order Online",
    "desktop-computer": "set up",
};
const displayNames = {
    youwin: "Win",
    "the-spark": "The Spark",
    "research-the-end": "The Beginning of The End",
    "mystic-coin": "Mystic Coin",
    "redeem-mc--science5": "Get: Science 5",
    "redeem-mc--assembler": "Get: Assembler",
    "research-minigames": "Tech: Mystic Coin",
    lumberjack: "Lumberjack",
    "lumberjack-school": "Lumberjack School",
    food: "Basic Food",
    assembler: "Assembler",
    constructer: "Constructor",
    money: "Money",
    electricity: "Electricity",
    desk: "Desk",
    "desktop-computer": "Desktop Computer",
    "small-battery": "Small Battery",
    "research-small-battery": "Tech: Electricity",
    "wind-turbine": "Wind Turbine",
    "miner-mk1": "Miner Mark I",
    "smelter-mk1": "Smelter",
    "smelter-mk2": "Foundry",
    "basic-circuit": "Basic Circuit",
    "chemical-plant": "Chemical Plant",
    manufacturer: "Manufacturer",
    "clean-water": "Clean Water",
    "research-wire": "Tech: Copper Wire",
    "research-steel": "Tech: Steel",
    "research-arbol": "Tech: Arbology",
    box: "Box",
    "box-box": "Box Box",
    box3: "Big Box",
    box4: "Massive Box",
    box5: "Biggest Box",
    "": "oops!",
    "adamantium-drill": "Adamantium Drill",
    "adamantium-frame": "Adamantium Frame",
    "advanced-circuit": "Advanced Circuit",
    "copper-bar": "Copper Bar",
    "copper-ore": "Copper Ore",
    "copper-wire": "Copper Wire",
    "crushed-uranium": "Crushed Uranium",
    "gas-extractor": "Gas Extractor",
    "iron-bar": "Iron Slab",
    "iron-frame": "Frame",
    "iron-ore": "Iron Ore",
    "oil-pump": "Oil Pump",
    "research-basic-circuit": "Tech: Basic Circuit",
    "research-adamantium-drill": "Tech: Adamantium Drill",
    "research-aluminum": "Tech: Aluminium",
    "research-assembler": "Tech: Assembler",
    "research-computer": "Tech: Computers",
    "research-explorer": "Tech: Explorer",
    "research-manufacturer": "Tech: Manufacturer",
    "research-natural-gas": "Tech: Natural Gas",
    "research-nitrogen": "Tech: Nitrogen Extraction",
    "research-studonite": "Tech: Strange Rock",
    "research-uranium": "Tech: Glowy Rock That Makes Me Feel Bad",
    "research-fluids": "Tech: Fluids",
    "research-oil": "Tech: Essential Oils",
    "research-frames": "Tech: Applications of Iron",
    "research-box": "Tech: Containerization",
    "research-constructor": "Tech: More Automation",
    "research-miner-mk1": "Tech: Auto Mining",
    "research-advanced-circuitry": "Tech: Advanced Circuits",
    "research-mass-click": "Tech: Mass Click",
    "research-woodcutting": "Tech: Wood",
    "research-metal": "Tech: Metals",
    "research-marg": "Tech: Marg",
    "research-car": "Car Parts Assembly Manual",
    "research-satisfy-button": "Tech: Satisfy",
    "rock-crusher": "Rock Crusher",
    adamantium: "Adamantium",
    "sulfuric-acid": "Sulfuric Acid",
    "uranium-ore": "Uranium Ore",
    "nuclear-fuel": "Nuclear Fuel Rod",
    "water-filter": "Water Filter",
    "water-pump-mk1": "Water Pump",
    gold: "Gold!",
    gear: "Iron Gear",
    "research-science-1": "Tech: Science 1",
    "research-science-3": "Tech: Science 3",
    "research-science-2": "Tech: Science 2",
    "research-science-4": "Tech: Science 4",
    "research-science-5": "Tech: Science 5",
    "research-science-6": "Tech: Science 6",
    "research-box2": "Tech: Box of a Bigger Size 1",
    "research-box3": "Tech: Box of a Bigger Size 2",
    "research-box4": "Tech: Box of a Bigger Size 3",
    "research-box5": "Tech: Box of a Bigger Size 4",
    tank: "Fluid Tank",
    prospector: "Prospector",
    explorer: "Explorer",
    steel: "Steel Ingot",
    pipe: "Steel Pipe",
    plastic: "Plastic Rod",
    studonite: "Studo-nite",
    bauxite: "Bauxite",
    aluminum: "Aluminium",
    solvent: "Acidic Solvent",
    computer: "Processor Unit",
    stone: "Stone",
    coal: "Coal",
    gas: "Natural Gas",
    "gold-filament": "Gold Filament",
    "coal-power": "Coal Burner",
    "nuclear-reactor": "Nuclear Reactor",
    begin: "Start Here",
    science0: "Basic Finding",
    science1: "Written Note",
    science2: "Documented Event",
    science3: "Intense Study",
    science4: "Research Paper",
    science5: "A.I. Generated Proof",
    science6: "A Bit of Magic",
    "wet-land": "Wet Land",
    "sandy-land": "Sandy Land",
    "copper-node": "Copper Deposit",
    "iron-node": "Iron Deposit",
    "coal-node": "Coal Deposit",
    "stony-land": "Stony Land",
    "oil-node": "Oil Well",
    "gold-node": "Gold Deposit",
    "studonite-node": "Studonite Deposit",
    "bauxite-node": "Bauxite Deposit",
    "uranium-node": "Uranium Deposit",
    telescope: "Telescope",
    "boost-lumberjack": "Boost: Sharper Axes",
    "boost-miner-mk1": "Boost: Tougher Drills",
    "boost-constructor": "Boost: new()",
    "boost-chemical-plant": "Boost: Precise Chemicals",
    "boost-adamantium-drill": "Boost: Adamantium Drill",
    "boost-gas-extractor": "Boost: Gas Extractor",
    "boost-lumberjack-school": "Boost: Better Teachers",
    "boost-oil-pump": "Boost: More Oil",
    "boost-rock-crusher": "Boost: Rock Crusher",
    "boost-smelter-mk1": "Boost: Hotter Smelters",
    "boost-smelter-mk2": "Boost: Efficient Foundries",
    "boost-assembler": "Boost: Faster Assembler",
    "boost-water-pump": "Boost: Bigger Water Pump",
    "boost-centrifuge": "Boost: Better Centrifuge",
    "boost-explorer": "Boost: Efficient Explorer",
    "boost-greenhouse": "Boost: Greener Greenhouse",
    "boost-manufacturer": "Boost: Manufacturer",
    "boost-wizard": "Boost: Pointer Hats",
    "boost-bank": "Boost: Faster Bean Counters",
    "boost-desktop-computer": "Boost: Faster Internet",
    car: "Car",
    chair: "A Chair",
    "anti-grav-thruster": "Anti-Grav Thruster",
    "arcane-wizard": "Arcane Wizard",
    "car-chassis": "Chassis",
    "car-engine": "Engine",
    "consume-arcane-wizard": "Consume Arcane Wizard",
    "consume-fire-wizard": "Consume Fire Wizard",
    "consume-necro-wizard": "Consume Necromancer",
    "consume-wizard-pop": "Convert Pops",
    "crank-shaft": "Crank Shaft",
    "engine-block": "Engine Block",
    "engine-electronics": "Engine Elec",
    "fire-wizard": "Fire Wizard",
    "lime-juice": "Lime Juice",
    "margarita": "Margarita",
    "necro-wizard": "Necromancer",
    "powerful-mana": "Powerful Mana",
    "raw-mana": "Raw Mana",
    "refined-mana": "Refined Mana",
    "research-money": "Research: Money",
    "research-wizard-tower": "Find Wizard Tower",
    "simple-syrup": "Simple Syrup",
    "spark-plug": "Spark Plug",
    "steering-wheel": "Steering Wheel",
    "wizard-degree": "Wizard Degree",
    "wizard-essence": "Wizard Essence",
    "wizard-orb": "Orb",
    "wizard-paragon": "Paragon",
    "wizard-pop": "Pop",
    "wizard-power": "Power",
    "research-wizards": "Study: Wizardry",
    "research-paragon": "Ascension: Paragon of Magic",
    "research-wizard-power": "Enlightenment: Wizardry Power",
    bank: "Bank",
    "wizard-hut": "Wizard Tower",
    "smooth-oil": "Lubricant",
};
const flavorText = {
    "research-mass-click": "Lets you place Boxes and Buildings 10 times as fast.",
    begin: (0, jsx_runtime_1.jsx)("b", { children: "The Beginning" }),
    prospector: (0, jsx_runtime_1.jsx)("i", { children: "Lets you find some land!" }),
    electricity: (0, jsx_runtime_1.jsx)("i", { children: "Power is Knowledge" }),
    "lumberjack-school": (0, jsx_runtime_1.jsx)("i", { children: "They learn all night, and they sleep all day." }),
    youwin: "Craft this to WIN!",
    money: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("b", { children: "Cash Money \uD83C\uDF89\uD83D\uDCB8\uD83D\uDCB0" }) }),
    bank: "Do you really need all this money?",
    science0: "Science 0",
    science1: "Science 1",
    science2: "Science 2",
    science3: "Science 3",
    science4: "Science 4",
    science5: "Science 5",
    science6: (0, jsx_runtime_1.jsxs)("span", { children: ["The 6th Science.", (0, jsx_runtime_1.jsx)("br", {}), "Allows you to see dead people."] }),
    "research-science-6": "Something strange is happening...",
    "boost-lumberjack": "Increase Lumberjack speed by 2x",
    "boost-miner-mk1": "Increase Miner Mark 1 speed by 2x",
    "boost-constructor": "Increase Constructor speed by 2x",
    "boost-chemical-plant": "Increase Chemical Plant speed by 2x",
    "boost-adamantium-drill": "Increase Adamantium Drill speed by 2x",
    "boost-gas-extractor": "Increase Gas Extractor speed by 2x",
    "boost-lumberjack-school": "Increase Lumberjack School speed by 2x",
    "boost-oil-pump": "Increase Oil Pumps speed by 2x",
    "boost-rock-crusher": "Increase Rock Crusher speed by 2x",
    "boost-smelter-mk1": "Increase Smelter speed by 2x",
    "boost-smelter-mk2": "Increase Foundry speed by 2x",
    "boost-assembler": "Increase Assembler speed by 2x",
    "boost-water-pump": "Increase Water Pump speed by 2x",
    "boost-centrifuge": "Increase Centrifuge speed by 2x",
    "boost-explorer": "Increase Explorer speed by 2x",
    "boost-greenhouse": "Increase Greenhouse speed by 2x",
    "boost-manufacturer": "Increase Manufacturer speed by 2x",
    "boost-wizard": "Increase Wizard and Orb speed by 2x",
    "wizard-hut": "A place for wizards to live",
    margarita: "A wizard's favorite drink.",
    car: "Transportation fit for a wizard.",
    "wizard-paragon": "The wizard of all time!",
};
const units = {
    electricity: "J",
    water: "m³",
};
exports.default = {
    byHandVerbs,
    displayNames,
    flavorText,
    units,
};
